import React from "react";
import "./Experience_Change.css";

function Experience_Change() {
  return (
    <>
      <section className="Experience_Change_holder">
        <div className="main-content-holder">
          <div className="heading-holder">
            <h4>Experience the Change</h4>
          </div>

          <div className="text-holder">
            <p>
              <b>At Videowala Bus Stand,</b> we believe travel should be
              stress-free and convenient. Our real-time ETA feature is designed
              to keep you informed, empowered, and always on schedule.
            </p>
          </div>
        </div>
        <div className="main-note-holder">
          <div className="note-holder">
            <p>
              Say goodbye to uncertainty and hello to smarter, more reliable
              journeys.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Experience_Change;
